import React from "react";
import { FlexPropsInterface } from "../../entities/Flex";
import { FlexStyled } from "./FlexStyled";

const Flex: React.FC<FlexPropsInterface> = ({
  children,
  styles,
  className = "generic-flex",
}) => (
  <FlexStyled
    direction={styles?.direction}
    align={styles?.align}
    justify={styles?.justify}
    wrap={styles?.wrap}
    className={className}
  >
    {children}
  </FlexStyled>
);

export default Flex;
